module.exports = __webpack_public_path__ + "static/media/acorncloud.c2c84733.png";